import { os } from '@balance-web/utils';

export const WINDOWS_ALT_KEY = 'Alt';
export const MAC_ALT_KEY = '⌥';
export const OS_ALT_KEY = os === 'mac' ? MAC_ALT_KEY : WINDOWS_ALT_KEY;

export const WINDOWS_CTRL_KEY = 'Ctrl';
export const MAC_CTRL_KEY = '⌃';
export const OS_CTRL_KEY = os === 'mac' ? MAC_CTRL_KEY : WINDOWS_CTRL_KEY;

export const WINDOWS_COMMAND_KEY = 'Win';
export const MAC_COMMAND_KEY = '⌘';
export const OS_COMMAND_KEY =
  os === 'mac' ? MAC_COMMAND_KEY : WINDOWS_COMMAND_KEY;
